import React from 'react';

import { NavLink, useLocation } from 'react-router-dom';

export default function LinkItem({ link }) {
  const location = useLocation();
  const { pathname } = location;

  const isActive = pathname.slice(1).startsWith(link.path);

  return (
    <li
      className={`px-3 py-2 rounded-sm mb-0.5 last:mb-0 ${
        isActive && 'bg-slate-900'
      }`}
    >
      <NavLink
        end
        to={`/${link.path}`}
        className={`block text-slate-200 truncate transition duration-150 ${
          isActive ? 'hover:text-slate-200' : 'hover:text-white'
        }`}
      >
        <div className="flex items-center">
          {link.icon(isActive)}
          <span className="text-sm font-medium ml-3 lg:opacity-0 lg:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200">
            {link.title}
          </span>
        </div>
      </NavLink>
    </li>
  );
}
